import React from 'react';
import { Link } from 'react-router-dom';
import { marked } from 'marked';

const StaticDocPage = ({ title, content }) => {
    return (
        <div className="min-h-screen bg-slate-950 text-slate-100" style={{ textAlign: 'left' }}>
            <header className="sticky top-0 z-10 bg-slate-900/90 backdrop-blur border-b border-white/10">
                <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <span className="text-2xl sm:text-[28px] font-semibold tracking-tight">
                            <span className="bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">FlashFonic</span>
                            <span className="align-top text-teal-400/70 text-xs">™</span>
                        </span>
                        <span className="text-slate-600 select-none">/</span>
                        <span className="text-sm text-slate-400">{title}</span>
                    </div>
                    <Link
                        to="/app/home"
                        className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm text-slate-200 bg-slate-800/70 hover:bg-slate-800 ring-1 ring-white/10 transition"
                    >
                        <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                        Back to App
                    </Link>
                </div>
            </header>

            <main className="max-w-3xl mx-auto px-6 py-10">
                <div
                    className="
                        prose prose-invert max-w-none
                        prose-headings:text-left prose-headings:font-semibold prose-headings:tracking-tight
                        prose-h1:text-2xl prose-h1:text-white prose-h1:mb-2
                        prose-h2:text-base prose-h2:text-slate-100 prose-h2:uppercase prose-h2:tracking-wider prose-h2:mt-10 prose-h2:mb-3 prose-h2:border-b prose-h2:border-white/10 prose-h2:pb-2
                        prose-h3:text-sm prose-h3:text-slate-200 prose-h3:mt-6 prose-h3:mb-2
                        prose-p:text-sm prose-p:text-slate-300 prose-p:leading-relaxed prose-p:text-left
                        prose-li:text-sm prose-li:text-slate-300 prose-li:leading-relaxed
                        prose-ul:text-left prose-ol:text-left
                        prose-strong:text-slate-100 prose-strong:font-semibold
                        prose-a:text-violet-400 prose-a:no-underline hover:prose-a:underline
                        [&>*]:text-left
                    "
                    dangerouslySetInnerHTML={{ __html: marked(content || '') }}
                />

                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col gap-1" style={{ textAlign: 'left' }}>
                    <p className="text-xs text-slate-500">© {new Date().getFullYear()} Trifecta Pro LLC · PO Box 265, Bennington, VT 05201</p>
                    <p className="text-xs text-slate-600">
                        Questions?{' '}
                        <a href="mailto:feedbackflashfonic@gmail.com" className="text-slate-400 hover:text-slate-300 underline">
                            feedbackflashfonic@gmail.com
                        </a>
                    </p>
                </div>
            </main>
        </div>
    );
};

export default StaticDocPage;
